import { useEffect, useRef, useState } from 'react'
import { createModel } from 'hox'
import useStorageState from '@/hooks/useStorageState'
import { globalPrompt } from '@/components/message'
import { IThreeTestItemDetail, IThreeTestItemSearch, threeTestItemService } from './threeTestItemService'
import { message } from 'antd'
import { debounce } from 'lodash'
import useGlobalModel from '@/model/globalModel'

type threeTestItemObj = {
    [key: string]: any
}

export type ITreeSelectData = {
    title: string
    selectable?: boolean
    children: ITreeSelectData[]
}

function listChangeTree(list: IThreeTestItemDetail[]) {
    let menuObj: threeTestItemObj = {}
    list.forEach((item) => {
        item.children = []
        menuObj[item.code] = item
    })
    return list.filter((item) => {
        if (!item.pcode) {
            item.pcode = null
        }
        if (item.pcode !== null && item.pcode !== '') {
            menuObj[item.pcode]?.children.push(item)
            return false
        }
        return true
    })
}

export const useThreeTestItemModel = createModel(function() {
    const [treeSource, setTreeSource] = useStorageState<any>('threeTestItemTree', []) //三检项目数据源
    const [oldTreeSource, setOldTreeSource] = useState<any>([]) //表单缓存
    const [selectedNodes, setSelectedNodes] = useState<IThreeTestItemDetail[]>([]) //树选中的行信息
    const [mode, setMode] = useState<'add' | 'nextAdd' | 'edit' | 'root' | 'compel' | ''>('') //模式
    const [qzShow, setQzShow] = useState<String>('') //模式
    const [formVal, setFormVal] = useState<IThreeTestItemDetail>(selectedNodes[0]) //表单缓存
    const {
        user: { shopCode, createUser }
    } = useGlobalModel(({ user }) => [user])
    const [searchParam, setSearchParam] = useState<string>('')
    const treeSourceRef = useRef<IThreeTestItemDetail[]>([])

    useEffect(() => {
        treeSourceRef.current = treeSource
    }, [treeSource])

    //实时缓存
    const onChangeFormVal = async (changedValues: { [key: string]: any }) => {
        if (mode === 'edit' && typeof changedValues.enableStatus === 'boolean') {
            await onSubmit({
                ...formVal,
                enableStatus: changedValues.enableStatus
            })
        }
        setFormVal({ ...formVal, ...changedValues })
    }

    //三检项目初始
    const initThreeTestItemFormFields = {
        pcode: '',
        code: '',
        name: '',
        ver: 0,
        sourceAuthKey: '',
        children: [],
        enable: 0,
        key: '',
        vehicleType: '',
        enableStatus: false
    }

    useEffect(() => {
        if (mode === 'add') {
            setFormVal({
                ...selectedNodes[0], ...initThreeTestItemFormFields,
                pcode: selectedNodes[0].pcode,
                code: selectedNodes[0].pcode as any,
                vehicleType: []
            })
        } else if (mode === 'nextAdd') {
            setFormVal({
                ...selectedNodes[0], ...initThreeTestItemFormFields,
                pcode: selectedNodes[0].code,
                code: selectedNodes[0].code,
                vehicleType: []
            })
        } else if (mode === 'root') {
            setSelectedNodes([initThreeTestItemFormFields])
            setFormVal(initThreeTestItemFormFields)
        } else if (qzShow === 'compel') {
            setFormVal({
                ...selectedNodes[0], ...initThreeTestItemFormFields,
                pcode: selectedNodes[0]?.code,
                code: selectedNodes[0]?.code,
                vehicleType: []
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mode])

    //三检项目列表请求
    const loadData = async (val: any) => {
        let data: IThreeTestItemSearch = {
            createUserId: shopCode,
            pageSize: -1,
            pageNum: 1,
            itemCreateUser: createUser
        }
        let { retData } = await threeTestItemService.page(data)
        let { records } = retData
        const newData: any = listChangeTree(
            records.map((item: any) => {
                return {
                    ...item,
                    vehicleType: item.vehicleType ? item.vehicleType.split(',').filter((v: string) => v) : [],
                    enableStatus: item.enableStatus === 'OPEN',
                    key: item.id
                }
            })
        )
        if (val === 'compel') {
            let _newData = JSON.parse(JSON.stringify(newData))
            let data: any = []
            compelTree(_newData).then((result) => {
                setTreeSource(result)
                setOldTreeSource(result)
                data = result
            })
            return data
        } else {
            setTreeSource(newData)
            setOldTreeSource(newData)
            return newData
        }
    }

    const compelTree = async (tree: any) => {
        function compel(node: any) {
            if (!node) return null
            if (node.enableStatus) {
                return node
            }
            node.children = (node.children || []).map((child: any) => compel(child)).filter((child: any) => child !== null)
            if (node.children.length === 0) {
                return null
            }
            return { ...node }
        }

        if (Array.isArray(tree)) {
            const compeldRoots = tree.map((root) => compel(root)).filter((root) => root !== null)
            if (compeldRoots.length === 0) {
                return []
            }
            return compeldRoots
        }
        const compeldSingleRoot = compel(tree)
        if (compeldSingleRoot === null) {
            return []
        }
        return compeldSingleRoot
    }

    function pruneTree(tree: any, targetName: any) {
        function prune(node: any) {
            if (!node) return null
            if (node.name.includes(targetName)) {
                return { ...node }
            }
            node.children = (node.children || []).map((child: any) => prune(child)).filter((child: any) => child !== null)
            if (node.children.length === 0) {
                return null
            }
            return { ...node }
        }

        if (Array.isArray(tree)) {
            const prunedRoots = tree.map((root) => prune(root)).filter((root) => root !== null)
            if (prunedRoots.length === 0) {
                return []
            }
            return prunedRoots
        }
        const prunedSingleRoot = prune(tree)
        if (prunedSingleRoot === null) {
            return []
        }
        return prunedSingleRoot
    }

    //表单提交
    const onSubmit = async (val: any) => {
        let { id, code, pcode, name, vehicleType } = val
        let data = {
            pcode,
            name,
            vehicleType,
            createUserId: shopCode,
            // createUser:"",
            enableStatus: val.enableStatus === true ? 'OPEN' : 'OFF',
            createUser: createUser
        }
        let nameList = false
        treeSource
            .find((item: any) => item.code === pcode)
            ?.children.forEach((list: any) => {
            if (list.name === name && (mode === 'nextAdd' || mode === 'root')) {
                message.warning('您不可添加重复三检项目名称！')
                nameList = true
            }
            if (list.name === name && list.code !== code && mode === 'edit') {
                message.warning('您不可修改为重复三检项目名称！')
                nameList = true
            }
        })
        if (nameList) {
            return
        }

        if (!data.name) {
            globalPrompt('message', { text: '请检查必填项', type: 'warning' })
            return
        }
        data.vehicleType = data.vehicleType ? data.vehicleType.filter((v: string) => v).join(',') : ''
        if (mode === 'nextAdd' || mode === 'root' || mode === 'add') {
            let { retData } = await threeTestItemService.insert([{ ...data }])
            retData && globalPrompt('message', { type: 'success', text: '三检项目增加成功' })
            loadData(qzShow).then((result) => {
                if (searchParam) {
                    let newData = JSON.parse(JSON.stringify(result))
                    setTreeSource(pruneTree(newData, searchParam))
                }
            })
            setSelectedNodes([])
        } else if (mode === 'edit') {
            let { retData } = await threeTestItemService.update({ ...data, createUser: createUser, id: id })
            retData && globalPrompt('message', { type: 'success', text: '三检项目编辑成功' })
            loadData(qzShow).then((result) => {
                if (searchParam) {
                    let newData = JSON.parse(JSON.stringify(result))
                    setTreeSource(pruneTree(newData, searchParam))
                }
            })
            // setSelectedNodes([]);
        }
    }

    //删除一条数据
    const removeOneThreeTestItem = async (id: string) => {
        let data = { id: id }
        globalPrompt('modal', {
            title: '删除',
            type: 'warning',
            text: '您是否删除此项三检项目？',
            okText: '确认',
            onOk: debounce(async () => {
                let { retData } = await threeTestItemService.remove([{ ...data }])
                retData && globalPrompt('message', { type: 'success', text: '三检项目删除成功' })
                loadData(qzShow).then((result) => {
                    if (searchParam) {
                        let newData = JSON.parse(JSON.stringify(result))
                        setTreeSource(pruneTree(newData, searchParam))
                    }
                })
                setSelectedNodes([])
            }, 500),
            cancelText: '取消',
            onCancel: () => {
            }
        })
    }

    return {
        /***field***/
        treeSource,
        selectedNodes,
        mode,
        formVal,
        oldTreeSource,
        qzShow,
        searchParam,
        /***method***/
        setSearchParam,
        setQzShow,
        setOldTreeSource,
        setTreeSource,
        setSelectedNodes,
        setMode,
        setFormVal,
        onChangeFormVal,
        loadData,
        onSubmit,
        removeOneThreeTestItem,
        compelTree,
        pruneTree
        // getSelectedThreeTestItemOne,
        // getTreeNodeName,
        // getTreeNodeOne,
        // getTreeSelectOne, sync,
        // getTreeNodeValue,
        // getTreeNodeNameValue,
        // getSelectedThreeTestItemValueOne,
        // getTreeNodeNameEn
    }
})
